<mwe-modal [model]="popupModel()">
  <h1
    class="h3"
    [translateParams]="{ total: totalSuggestions(), current: currentSuggestionIdx() }"
    translate="association-suggestions.stepTitle"
  ></h1>
  <p translate="association-suggestions.stepMessage"></p>

  @for (group of currentSuggestions(); track group.address.hashCode) {
    @if (group) {
      <mwe-products-group
        [address]="group.address"
        [productsInput]="group.products"
        [showCompanyCorrelation]="true"
        state="list"
        [isClickableCard]="false"
      />
    }
  }
  @if (isError()) {
    <mwe-alert messageKey="error.service.default.message" titleKey="error.service.default.title" type="danger" />
  }
  <mwe-dsgvo-disclaimer />
  <ng-container slot="footer">
    <div class="p-4 bg-gray--200">
      <div class="row g-3 justify-content-between">
        <div class="col-md-auto">
          <mwe-button
            color="blue"
            [hasFullWidth]="true"
            labelKey="association-suggestions.buttonOK"
            (clicked)="addSuggestion()"
            [buttonId]="'mwe-association-suggestions-submit'"
            [disabled]="isSubmittingAdd() || isSubmittingIgnore()"
            [showSpinner]="isSubmittingAdd()"
          />
        </div>
        <div class="col-md-auto">
          <mwe-button
            color="blue"
            category="secondary"
            [hasFullWidth]="true"
            labelKey="association-suggestions.buttonNOK"
            (clicked)="ignoreSuggestion()"
            [buttonId]="'mwe-association-suggestions-cancel'"
          />
        </div>
      </div>
    </div>
  </ng-container>
</mwe-modal>
